import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";

const included = [
  "Bespoke needs assessment for your organisation",
  "Full 2-Day Adult MHFA training for nominated first aiders",
  "Quarterly refresher check-ins and skills practice",
  "MHFA Aware sessions rolled out to the wider team",
  "Ongoing supervision & signposting for MHFAiders",
  "Impact reporting for HR & leadership",
];

export default function SupportPackages() {
  return (
    <section data-testid="packages-section" className="section relative overflow-hidden bg-[#F3EFEA]">
      <div className="floral-blob w-[500px] h-[500px] bg-[#D88C76]/25 -top-40 right-[-140px]" />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6"
          >
            <p className="eyebrow mb-4">12-Month Support Package</p>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#1E2A25]">
              More than a <br />
              <span className="italic text-[#4A5D52]">two-day course.</span>
            </h2>
            <p className="mt-8 text-lg text-[#4A5D52] leading-relaxed max-w-xl">
              For organisations serious about workplace wellbeing, we offer year-long support
              packages that embed MHFA into your culture — not just your calendar.
            </p>
            <div className="mt-10">
              <Link to="/contact" data-testid="packages-cta" className="btn-primary">
                Design your package <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-6"
          >
            <div className="bg-[#FDFBF7] rounded-3xl p-8 md:p-10 border border-[#8DA399]/30">
              <div className="flex items-baseline justify-between mb-8">
                <h3 className="font-serif-display text-3xl text-[#1E2A25]">What&apos;s included</h3>
                <span className="eyebrow text-[#D88C76]">Example</span>
              </div>
              <ul className="space-y-4">
                {included.map((item, i) => (
                  <li key={i} data-testid={`package-item-${i}`} className="flex items-start gap-3 text-[#1E2A25]/85">
                    <span className="w-6 h-6 rounded-full bg-[#4A5D52]/10 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <Check className="w-3.5 h-3.5 text-[#4A5D52]" strokeWidth={2.5} />
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-10 pt-6 border-t border-[#8DA399]/25 text-sm text-[#4A5D52] italic">
                Every package is tailored — sample only. Speak with Liz to build yours.
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
